// Client-side synthesized "stadium roar" — WebAudio API, zero downloads.
let _ctx = null;
function getCtx() {
  if (_ctx) return _ctx;
  const C = window.AudioContext || window.webkitAudioContext;
  if (!C) return null;
  _ctx = new C();
  return _ctx;
}

export function playStadiumRoar() {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === "suspended") ctx.resume();
  const now = ctx.currentTime;

  // --- Referee whistle (chirp) ---
  const whistle = ctx.createOscillator();
  const wg = ctx.createGain();
  whistle.type = "square";
  whistle.frequency.setValueAtTime(2400, now);
  whistle.frequency.exponentialRampToValueAtTime(3800, now + 0.12);
  whistle.frequency.exponentialRampToValueAtTime(2100, now + 0.45);
  wg.gain.setValueAtTime(0.0001, now);
  wg.gain.exponentialRampToValueAtTime(0.22, now + 0.05);
  wg.gain.exponentialRampToValueAtTime(0.0001, now + 0.5);
  whistle.connect(wg).connect(ctx.destination);
  whistle.start(now);
  whistle.stop(now + 0.55);

  // --- Crowd roar (band-pass noise) ---
  const dur = 3.2;
  const buf = ctx.createBuffer(1, ctx.sampleRate * dur, ctx.sampleRate);
  const data = buf.getChannelData(0);
  for (let i = 0; i < data.length; i++) {
    // Pinkish noise
    data[i] = (Math.random() * 2 - 1) * (0.5 + 0.4 * Math.sin(i / 800));
  }
  const src = ctx.createBufferSource();
  src.buffer = buf;
  const filter = ctx.createBiquadFilter();
  filter.type = "bandpass";
  filter.frequency.value = 750;
  filter.Q.value = 0.6;
  const g = ctx.createGain();
  g.gain.setValueAtTime(0.0001, now + 0.25);
  g.gain.exponentialRampToValueAtTime(0.55, now + 0.9);
  g.gain.setValueAtTime(0.55, now + 2.0);
  g.gain.exponentialRampToValueAtTime(0.0001, now + dur + 0.25);
  src.connect(filter).connect(g).connect(ctx.destination);
  src.start(now + 0.25);
  src.stop(now + dur + 0.3);
}

// Unlock audio on first user gesture (browser policy).
export function unlockAudio() {
  const ctx = getCtx();
  if (ctx && ctx.state === "suspended") ctx.resume().catch(() => {});
}
